import React from "react";
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import FvIcon from "./ImagesComponents/favicon4848.png"
import HeaderNew from "./Components/HeaderComponents/HeaderNew";
import Home from "./Components/HomeComponents/Home";
import Prices from "./Components/PricesComponents/Prices";
import PpcPrice from "./Components/PPcComponents/PpcPrice";
import SmoPrice from "./Components/SmoPriceComponents/SmoPrice";
import LocalSeo from "./Components/LocalSeoComponents/LocalSeo";
import NoteFound from "./Components/NoteFound";
import Footer from "./Components/FooterComponent/Footer";
import ScrollTop from "./ScrollTop";
import EcommerceSeo from "./Components/ECommerceSeoComponents/EcommerceSeo";
import ContentMarketingServ from "./Components/ContentMarketingComponents/ContentMarketingServ";
import SocialMediaMarketing from "./Components/SocialMediaMarketingComponents/SocialMediaMarketing";
import ReputationManagementServ from "./Components/ReputationManagementComponents/ReputationManagementServ";
import PpcMarketing from "./Components/PpcMarketingComponents/PpcMarketing";
import SingleCaseStudy from "./Components/WhoWeAreComponents/SingleCaseStudy";
import CancellationPolicy from "./Components/FooterComponent/CancellationPolicy";
import PrivacyPolicy from "./Components/FooterComponent/PrivacyPolicy";
import TermsAndConditions from "./Components/FooterComponent/TermsAndConditions";
import MainService from "./Components/MainServiceComponents/MainService";
import CbdIndex from "./Components/CbdComponents/CbdIndex";
import AmazonPrice from "./Components/AmazonPricingComponents/AmazonPrice";
import ContactUs from "./Components/ContactusComponents/ContactUs";
import SeoTraffic from "./Components/SeoTrafficComponetns/SeoTraffic";
import SeoAmazon from "./Components/SeoAmazonComponents/SeoAmazon";
import WhoWeAre from "./Components/WhoWeAreComponents/WhoWeAre";
import Review from "./Components/ReviewComponents/Review";
import GoogleAds from "./Components/GoogleAdsComponents/GoogleAds";
import ReactGA from "react-ga4";
import "owl.carousel/dist/assets/owl.carousel.css";
import "./index.css";
import "../src/css/bootstrap.min.css";
import "../src/css/rsmenu-main.css";
import "./css/custom.css";
import "../src/css/style2.css";
import "owl.carousel";
import CityAllData from "./Components/CitiesSpecificComponents/CityAllData";
// import StateDataDisplay from "./Components/StateSpacificDataComponents/StateDataDisplay";
import LocationMainPage from "./Components/AllLocationComponents/LocationMainPage";
import NewYorkCity from "./Components/NewYorkNew/NewYorkCity"
import cities from "./Components/CitiesSpecificComponents/CityDataObject";

const Track_Id = "G-11JQSGFZGB";
ReactGA.initialize(Track_Id);

const App = () => {
  const citiesId = cities.find(citiesId => citiesId.valueOf);
  console.log(citiesId)
  return (
    <Router>
      <ScrollTop />
      <div className="app">
        <Helmet>
        <link rel="icon" type="image/ico" sizes="48x48" href={FvIcon} />
        <meta name="description"
    content=": EZ Marketing Agency is a leading SEO company in West Hollywood, California, offering efficient SEO, SMO, PPC, Local SEO, Technical SEO optimization, and quality link-building services. Call us @ +1 (855) 781-2099" />
          <link rel="canonical" href={window.location.origin + window.location.pathname} />
        </Helmet>
        <HeaderNew />
        <Routes>
          <Route exact path="/us" element={<Home />} />
          <Route exact path="/us/main-service" element={<MainService />} />
          <Route exact path="/us/seo-services" element={<SeoTraffic />} />
          <Route exact path="/us/amazon-seo-services" element={<SeoAmazon />} />
          <Route exact path="/us/who-we-are" element={<WhoWeAre />} />
          <Route exact path="/us/seo-packages" element={<Prices />} />
          <Route exact path="/us/ppc-packages" element={<PpcPrice />} />
          <Route exact path="/us/amazon-price" element={<AmazonPrice />} />
          <Route
            exact
            path="/us/social-media-marketing-packages"
            element={<SmoPrice />}
          />
          <Route exact path="/us/local-seo-packages" element={<LocalSeo />} />
          <Route exact path="/us/contact-us" element={<ContactUs />} />
          <Route exact path="/us/reviews" element={<Review />} />
          <Route exact path="/us/city/seo-company-new-york-city" element={<NewYorkCity />} />
          <Route
            exact
            path="/us/social-media-marketing"
            element={<SocialMediaMarketing />}
          />
         
          <Route exact path="/us/:slug" element={<LocationMainPage/>} />
          <Route exact path="/us/services-ads" element={<GoogleAds />} />
          <Route exact path={"/us/city/:id"} element={<CityAllData />} />
          <Route
            exact
            path="/us/ecommerce-seo-services"
            element={<EcommerceSeo />}
          />
          <Route
            exact
            path="/us/content-marketing-services"
            element={<ContentMarketingServ />}
          />
          <Route
            exact
            path="/us/social-media-marketing-services"
            element={<SocialMediaMarketing />}
          />
          <Route
            exact
            path="/us/reputation-management-services"
            element={<ReputationManagementServ />}
          />
          <Route
            exact
            path="/us/cancellation-policy"
            element={<CancellationPolicy />}
          />

          <Route exact path="/us/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/us/terms-and-conditions" element={<TermsAndConditions />} />
          <Route exact path="/us/cbd" element={<CbdIndex />} />
          <Route
            exact
            path="/us/case-study/:ShortHeading"
            element={<SingleCaseStudy />}
          />
          <Route exact path="/us/ppc-marketing" element={<PpcMarketing />} />
          {/* <Route
            exact
            path="/us/seo-company-new-york"
            element={<NewYorkSeoServices />}
          /> */}
          <Route path="*" exact={true} element={<NoteFound />} />
          {/* navigate routes */}
          <Route
            exact
            path="/pricing"
            element={<Navigate to="/seo-packages" />}
          />
          <Route
            exact
            path="https://ezmarketing.agency/blog/"
            element={<Navigate to="https://ezmarketing.agency/blog" />}
          />
          <Route
            exact
            path="/cdn-cgi/challenge-platform/h/b"
            element={<Navigate to="/" />}
          />
          <Route
            exact
            path="/cdn-cgi/challenge-platform/h/b/scripts/cb/invisible.js?cb=7b2a7e351b53c3ac"
            element={<Navigate to="/" />}
          />
          <Route
            exact
            path="/cdn-cgi/challenge-platform/h/b/scripts/cb/invisible.js?cb=7a7aadd44ad48262"
            element={<Navigate to="/" />}
          />
          <Route
            exact
            path="/about-us"
            element={<Navigate to="/who-we-are" />}
          />
          <Route
            exact
            path="/services"
            element={<Navigate to="/us/amazon-seo-services" />}
          />

          <Route
            exact
            path="/cancellation-and-refund-policy"
            element={<Navigate to="/cancellation-policy" />}
          />
          <Route
            exact
            path="/blog/the-benefits-of-engine-optimization-for-small-businesses"
            element={
              <Navigate to="/blog" />
            }
          />
          <Route
            exact
            path="/blog/blog/__trashed/"
            element={
              <Navigate to="/blog" />
            }
          />
          <Route
            exact
            path="/blog/the-importance-of-anchor-text/"
            element={
              <Navigate to="/blog" />
            }
          />
          <Route
            exact
            path="/blog/address/"
            element={
              <Navigate to="/blog" />
            }
          />
           <Route
            exact
            path="/blog/online-strategy/"
            element={
              <Navigate to="/blog" />
            }
          />
          <Route
            exact
            path="/blog/how-to-block-website-referral-spam/"
            element={
              <Navigate to="/blog" />
            }
          />
          <Route
            exact
            path="/services/seo"
            element={<Navigate to="/seo-services" />}
          />
          <Route
            exact
            path="/pricing/ppc-packages"
            element={<Navigate to="/ppc-packages" />}
          />
          <Route
            exact
            path="/pricing/seo-packages"
            element={<Navigate to="/seo-packages" />}
          />
          <Route
            exact
            path="/services/ppc-management"
            element={<Navigate to="/ppc-marketing" />}
          />
          <Route
            exact
            path="/locationtexas"
            element={<Navigate to="/seo-company-texas" />}
          />
          <Route exact path="/cbdIndex" element={<Navigate to="/cbd" />} />

          <Route
            exact
            path="/blog/online-strategy"
            element={
              <Navigate to="/blog/the-importance-of-a-solid-digital-marketing-strategy" />
            }
          />

          <Route exact path="/blog/address" element={<Navigate to="/blog" />} />
          <Route exact path="/blog/the-benefits-of-engine-optimization-for-small-businesses" element={<Navigate to="/blog/" />} />
          <Route exact path="/blog/__trashed/" element={<Navigate to="/blog/" />} />
          <Route exact path="/blog/the-importance-of-anchor-text/" element={<Navigate to="/blog/" />} />
          <Route exact path="/blog/address/" element={<Navigate to="/blog/" />} />
          <Route exact path="/blog/online-strategy/" element={<Navigate to="/blog/" />} />
          <Route exact path="/blog/how-to-block-website-referral-spam/" element={<Navigate to="/blog/" />} />
          <Route
            exact
            path="/pricing/web-packages/"
            element={<Navigate to="/" />}
          />
          <Route
            exact
            path="/blog/how-to-block-website-referral-spam"
            element={
              <Navigate to="/blog/how-to-block-website-referral-spam-2" />
            }
          />

          <Route
            exact
            path="/blog/the-benefits-of-search-engine-optimization-for-small-businesses"
            element={
              <Navigate to="/blog/the-benefits-of-search-engine-optimization-seo-for-small-businesses-2" />
            }
          />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
  
};

export default App;
